import { Component, Input, Output, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'as-select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.scss']
})
export class SelectListComponent implements OnInit {

  @Input() list;
  @Input() placeholder;
  @Output() selected = new EventEmitter()

  textInput;
  displayList;

  constructor() { }

  ngOnInit() {
  }

  updateText(input){

    // this.displayList =  this.list.filter((g)=>g.name.toLowerCase().includes(input));

    if (input.length > 1){
      this.displayList =  this.list.filter((g)=>g.name.toLowerCase().includes(input));
    }

    if (input.length == 0){    
      this.displayList = [];
    }
  }

  processSelected(selected){
    this.displayList = [];
    this.textInput = "";
    this.selected.emit(selected)
  }

}
